<div class="modal-container">
  <!-- Top Header with Buttons -->
  <div mat-dialog-title class="modal-header">
      <div style="display: flex; align-items: center; justify-content: space-between; width: 100%;">
          <span style="text-transform: uppercase;">{{data?.formName}}</span>
          <div style="display: flex; gap: 8px;">
              <button mat-button (click)="cancel()">Cancel</button>
              <button mat-raised-button color="primary" (click)="saveChanges()">Save</button>
          </div>
      </div>
  </div>

  <!-- Content Body -->
  <mat-dialog-content class="modal-body">
    <form [formGroup]="formlyForm">
        <formly-form 
        [form]="formlyForm" 
        [fields]="formlyFields" 
        [model]="dataModel"
        [options]="options"></formly-form>
    </form>
  </mat-dialog-content>
</div>
